export enum ETopBetsErrorCode {
  /** услуга размещения не поддерживает ставки лидеров **/
  serviceNotSupported = 'serviceNotSupported',
  /** адрес объявления не указан **/
  geoEmpty = 'geoEmpty',
  /** цена объявления не указана **/
  priceEmpty = 'priceEmpty',
  /** адрес и цена объявления не указаны **/
  priceAndGeoEmpty = 'priceAndGeoEmpty',
  /** неверный запрос **/
  badRequest = 'badRequest',
  /** неизвестная ошибка на сервере */
  fatalError = 'fatalError',
}
